/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { put, select, takeLatest } from 'redux-saga/effects'
import { setTotalCGSScore } from '../store/vitals.actions'
import { VitalsConstants } from '../store/vitals.constants'
import { IPatientVitals } from '../store/vitals.types'
import { getPatientVitalsSelector } from '../selectors/patientVitals.selector'

export function* getTotalGCSScore() {
  const patientVital: IPatientVitals = yield select(getPatientVitalsSelector)
  const { verbalResponseScore, motorResponseScore, eyeOpeningResponseScore } = patientVital
  patientVital.totalGCSScore = verbalResponseScore + motorResponseScore + eyeOpeningResponseScore
  if (
    !patientVital.totalGCSScore ||
    patientVital.totalGCSScore < 3 ||
    !eyeOpeningResponseScore ||
    !verbalResponseScore ||
    !motorResponseScore
  ) {
    patientVital.totalGCSScore = null
    yield put(setTotalCGSScore(patientVital.totalGCSScore))
  }
}

export function* setTotalGCSScoreSaga() {
  yield takeLatest(
    [
      VitalsConstants.SET_MOTOR_RESPONSE_SCORE,
      VitalsConstants.SET_VERBAL_RESPONSE_SCORE,
      VitalsConstants.SET_EYE_OPENING_RESPONSE_SCORE,
    ],
    getTotalGCSScore
  )
}
